<div class="row" [scAnchorTarget]="'ScreeningQuestions'" *ngIf="candidate.ScreeningAnswers?.length">

    <div class="col-12">

        <ul class="list-group list-group-flush fw-normal">

            <li *ngFor="let q of candidate.ScreeningAnswers" class="list-group-item">

                <div class="row">
                    <div class="col-12 col-md-10">
                        <div class="mb-3 text-muted" [innerHTML]="q.QuestionString"></div>
                        <p class="mt-0 mb-0 fw-bold">{{ q.AnswerString }}</p>
                    </div>
                </div>

            </li>

        </ul>

    </div>
</div>
